import styled from 'styled-components';

export const AuthWrapper = styled.div`
  min-height: calc(100vh - 40px - 62px);
`;
